module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAYCAYAAADpnJ2CAAAAAXNSR0IArs4c6QAAAHpJREFUSA1jZI5j9vz3n2EWAwODDBAjACPDYyYGhvS/i/5uBwlSSx0TVstANvxnkP3HwDATxAQBaqkDeoK+gImJkSENaOUTDGuhQQoTp7Y6mLmj9GgIDL4QYKRWCUJsiTRa0qTDUsFoSQMLiVF6+IfAaElD9Time5sGAM/hhh1IbYZIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/density-comfy2x.png
// module id = N8jt
// module chunks = 47